import { clearStorage } from "../../config/config";
/**
 * API service to logout
 * @param {string} url
 * @param {string} xClientId
 * @returns {Object}
 */
const logutApi = async ({ url, XClient_ID }: { [key: string]: string }) => {
  try {
    const jsonData = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "X-Client-Id": XClient_ID,
      },
      method: "DELETE",
      credentials: "include",
    });
    if (jsonData.status >= 200 && jsonData.status <= 300) {
      clearStorage();
      return {
        status: "Success",
        error: "",
      };
    } else {
      throw "Something went wrong";
    }
  } catch (err) {
    return {
      status: "Failuire",
      error: err,
    };
  }
};
export default logutApi;
